<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header [currentUser]="currentUser" (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav [isMobileMenuOpen]="isMobileMenuOpen" (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">ตรวจสอบการชำระเงิน</h1>
          <p class="page-subtitle">ตรวจสอบหลักฐานการโอน ปรับสถานะการชำระเงิน และออกใบเสร็จ</p>
        </div>

        <!-- Error Alert -->
        <ngb-alert *ngIf="error" type="danger" [dismissible]="true" class="mb-3">
          {{ error }}
        </ngb-alert>

        <!-- Status Tabs (รวมทั้งหมด + 6 ประเภทใบคำขอ) -->
        <div class="status-tabs-container">
          <div class="status-tabs">
            <button *ngFor="let tab of tabs" type="button" class="status-tab" [class.active]="activeTab === tab.id"
              (click)="switchTab(tab.id)">
              <span class="tab-label">{{ tab.label }}</span>
              <span *ngIf="activeTab === tab.id" class="badge bg-light text-dark ms-2">{{ collectionSize }}</span>
            </button>
          </div>
        </div>

        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-header">
            <h3>ตัวกรอง</h3>
            <button type="button" class="clear-filters-btn" (click)="clearFilters()">
              ล้างตัวกรอง
            </button>
          </div>

          <div class="filters-grid">
            <div class="filter-group">
              <label class="form-label">ค้นหาทั่วไป</label>
              <input type="text" class="form-control" [(ngModel)]="filters.searchTerm" (ngModelChange)="applyFilters()"
                placeholder="อีเมล, ชื่อ-นามสกุล, เลขที่ใบเสร็จ, รายการ">
            </div>

            <div class="filter-group">
              <label class="form-label">อีเมล</label>
              <input type="text" class="form-control" [(ngModel)]="filters.email" (ngModelChange)="applyFilters()"
                placeholder="อีเมลผู้ใช้">
            </div>

            <div class="filter-group">
              <label class="form-label">เลขที่ใบเสร็จ</label>
              <input type="text" class="form-control" [(ngModel)]="filters.codeReceipt"
                (ngModelChange)="applyFilters()" placeholder="เช่น mem-69-000001">
            </div>

            <div class="filter-group">
              <label class="form-label">ชื่อรายการ</label>
              <input type="text" class="form-control" [(ngModel)]="filters.itemTitle" (ngModelChange)="applyFilters()"
                placeholder="ชื่อรายการ / ประเภท">
            </div>

            <div class="filter-group">
              <label class="form-label">สถานะการชำระเงิน</label>
              <select class="form-select" [(ngModel)]="filters.paymentStatus" (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option *ngFor="let status of allPaymentStatuses" [value]="status">{{ status }}</option>
              </select>
            </div>

            <div class="filter-group">
              <label class="form-label">จำนวนเงินขั้นต่ำ</label>
              <input type="number" class="form-control" [(ngModel)]="filters.amountMin" (ngModelChange)="applyFilters()"
                placeholder="0.00" min="0" step="0.01">
            </div>

            <div class="filter-group">
              <label class="form-label">จำนวนเงินสูงสุด</label>
              <input type="number" class="form-control" [(ngModel)]="filters.amountMax" (ngModelChange)="applyFilters()"
                placeholder="999999.99" min="0" step="0.01">
            </div>

            <div class="filter-group">
              <label class="form-label">วันที่ทำรายการเริ่มต้น</label>
              <input type="date" class="form-control" [(ngModel)]="filters.dateFrom" (ngModelChange)="applyFilters()">
            </div>

            <div class="filter-group">
              <label class="form-label">วันที่ทำรายการสิ้นสุด</label>
              <input type="date" class="form-control" [(ngModel)]="filters.dateTo" (ngModelChange)="applyFilters()">
            </div>
          </div>

          <div class="d-flex gap-2 mt-3">
            <button type="button" class="btn btn-outline-success" (click)="exportToCSV()"
              [disabled]="collectionSize === 0">
              <i class="bi bi-file-earmark-excel me-2"></i>Export CSV
            </button>
            <button type="button" class="btn btn-primary" (click)="refreshData()">
              <i class="bi bi-arrow-clockwise me-2"></i>รีเฟรชข้อมูล
            </button>
          </div>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="account-worklist-container">
          <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>กำลังโหลดข้อมูลรายการชำระเงิน...</p>
          </div>
        </div>

        <!-- Payment Records Table -->
        <div class="card" *ngIf="!isLoading">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">รายการชำระเงิน</h5>
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
              </select>
            </div>
          </div>

          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-striped table-hover mb-0">
                <thead class="table-light">
                  <tr>
                    <!-- แท็บรวมทั้งหมดต้องรู้ว่าแต่ละแถวมาจากใบคำขอประเภทไหน -->
                    <th scope="col" *ngIf="activeTab === 'all'">ประเภทรายการ</th>
                    <!-- 1. วันและเวลาที่ User เข้าทำรายการในระบบ -->
                    <th scope="col" class="sortable" (click)="sortBy('submittedAt')"
                      [class.sorted]="isSortedBy('submittedAt')" title="คลิกเพื่อเรียงลำดับ">
                      วันและเวลาที่ทำรายการ {{ getSortIcon('submittedAt') }}
                    </th>
                    <!-- 2. ชื่อ-นามสกุล User -->
                    <th scope="col" class="sortable" (click)="sortBy('name')" [class.sorted]="isSortedBy('name')"
                      title="คลิกเพื่อเรียงลำดับ">
                      ชื่อ-นามสกุล {{ getSortIcon('name') }}
                    </th>
                    <!-- 3. เลขที่สมาชิกสมาคม -->
                    <th scope="col" class="sortable" (click)="sortBy('memberNo')"
                      [class.sorted]="isSortedBy('memberNo')" title="คลิกเพื่อเรียงลำดับ">
                      เลขที่สมาชิกสมาคม {{ getSortIcon('memberNo') }}
                    </th>
                    <!-- 4. บริษัท/หน่วยงาน -->
                    <th scope="col" class="sortable" (click)="sortBy('organization')"
                      [class.sorted]="isSortedBy('organization')" title="คลิกเพื่อเรียงลำดับ">
                      บริษัท/หน่วยงาน {{ getSortIcon('organization') }}
                    </th>
                    <!-- 5. ชื่อรายการ -->
                    <th scope="col" class="sortable" (click)="sortBy('itemTitle')"
                      [class.sorted]="isSortedBy('itemTitle')" title="คลิกเพื่อเรียงลำดับ">
                      ชื่อรายการ {{ getSortIcon('itemTitle') }}
                    </th>
                    <!-- 6. จำนวนเงิน -->
                    <th scope="col" class="sortable text-end" (click)="sortBy('amount')"
                      [class.sorted]="isSortedBy('amount')" title="คลิกเพื่อเรียงลำดับ">
                      จำนวนเงิน {{ getSortIcon('amount') }}
                    </th>
                    <!-- 7. สถานะการชำระเงิน -->
                    <th scope="col" class="sortable text-center" (click)="sortBy('paymentStatus')"
                      [class.sorted]="isSortedBy('paymentStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการชำระเงิน {{ getSortIcon('paymentStatus') }}
                    </th>
                    <!-- 8. วันที่และเวลาชำระเงิน -->
                    <th scope="col" class="sortable" (click)="sortBy('paidAt')" [class.sorted]="isSortedBy('paidAt')"
                      title="คลิกเพื่อเรียงลำดับ">
                      วันที่และเวลาชำระเงิน {{ getSortIcon('paidAt') }}
                    </th>
                    <!-- 9. หลักฐานการชำระเงิน -->
                    <th scope="col" class="sortable text-center" (click)="sortBy('paymentSlip')"
                      [class.sorted]="isSortedBy('paymentSlip')" title="คลิกเพื่อเรียงลำดับ (มี/ไม่มีหลักฐาน)">
                      หลักฐานการชำระเงิน {{ getSortIcon('paymentSlip') }}
                    </th>
                    <!-- 10. ออกใบเสร็จ -->
                    <th scope="col" class="sortable text-center" (click)="sortBy('codeReceipt')"
                      [class.sorted]="isSortedBy('codeReceipt')" title="คลิกเพื่อเรียงลำดับ">
                      ออกใบเสร็จ {{ getSortIcon('codeReceipt') }}
                    </th>
                    <th scope="col" class="text-center">จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- No Data Row -->
                  <tr *ngIf="getCurrentPageRecords().length === 0">
                    <td [attr.colspan]="activeTab === 'all' ? 12 : 11" class="text-center py-4">
                      <div class="text-muted">
                        <i class="bi bi-inbox"></i>
                        <p class="mb-0">ไม่พบข้อมูลรายการชำระเงิน</p>
                        <small *ngIf="records.length > 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                        <small *ngIf="records.length === 0">ไม่มีข้อมูลในระบบ</small>
                      </div>
                    </td>
                  </tr>

                  <!-- Record Rows -->
                  <tr *ngFor="let record of getCurrentPageRecords(); trackBy: trackByRecordId">
                    <!-- ประเภทรายการ (เฉพาะแท็บรวมทั้งหมด) -->
                    <td *ngIf="activeTab === 'all'" class="text-nowrap">
                      <span class="badge bg-light text-dark border">{{ getTypeLabel(record.sourceType) }}</span>
                    </td>

                    <!-- 1. วันและเวลาที่ User เข้าทำรายการในระบบ -->
                    <td class="text-nowrap">{{ formatDateTime(record.submittedAt) }}</td>

                    <!-- 2. ชื่อ-นามสกุล User (คลิกเพื่อเปิดใบคำขอ) -->
                    <td class="fw-semibold">
                      <button type="button" class="btn btn-link p-0 text-start fw-semibold applicant-link"
                        (click)="viewRequestDetail(record)" [ngbTooltip]="'เปิดใบคำขอของผู้ทำรายการ'">
                        {{ record.fullName || '-' }}
                      </button>
                      <div class="text-muted small">{{ record.email || '-' }}</div>
                    </td>

                    <!-- 3. เลขที่สมาชิกสมาคม -->
                    <td class="text-nowrap"><span class="font-monospace">{{ record.memberNo || '-' }}</span></td>

                    <!-- 4. บริษัท/หน่วยงาน -->
                    <td>{{ record.organization || '-' }}</td>

                    <!-- 5. ชื่อรายการ -->
                    <td>{{ record.itemTitle || '-' }}</td>

                    <!-- 6. จำนวนเงิน -->
                    <td class="text-end text-nowrap">
                      <strong>{{ formatCurrency(record.amount) }}</strong> บาท
                    </td>

                    <!-- 7. สถานะการชำระเงิน -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getStatusBadgeClass(record.paymentStatus)">
                        {{ record.paymentStatus || '-' }}
                      </span>
                    </td>

                    <!-- 8. วันที่และเวลาชำระเงิน -->
                    <td class="text-nowrap">{{ getPaidAt(record) }}</td>

                    <!-- 9. หลักฐานการชำระเงิน (ย่อ-ขยายได้) -->
                    <td class="text-center">
                      <button *ngIf="record.paymentSlip" class="btn btn-sm btn-outline-primary" type="button"
                        (click)="openSlipPreview(record.paymentSlip!)" [ngbTooltip]="'ดูหลักฐานการชำระเงิน'">
                        <i class="bi bi-receipt me-1"></i>ดูหลักฐาน
                      </button>
                      <span *ngIf="!record.paymentSlip" class="text-muted">-</span>
                    </td>

                    <!-- 10. ออกใบเสร็จ (คลิกเพื่อพิมพ์ พร้อมเลขที่ใบเสร็จกำกับ) -->
                    <td class="text-center">
                      <button *ngIf="hasReceipt(record)" type="button" class="btn btn-sm btn-success receipt-btn"
                        (click)="printReceipt(record)" [ngbTooltip]="'พิมพ์ใบเสร็จ/ใบกำกับภาษี'">
                        <i class="bi bi-printer me-1"></i>
                        <span class="font-monospace">{{ record.codeReceipt }}</span>
                      </button>
                      <span *ngIf="!hasReceipt(record)" class="text-muted">ยังไม่ออกใบเสร็จ</span>
                    </td>

                    <!-- Action -->
                    <td class="text-center">
                      <div ngbDropdown container="body" class="d-inline-block">
                        <button type="button" class="btn btn-sm btn-primary" ngbDropdownToggle>
                          <i class="bi bi-gear me-1"></i>จัดการ
                        </button>
                        <div ngbDropdownMenu>
                          <button ngbDropdownItem type="button" (click)="viewPaymentDetail(record)">
                            <i class="bi bi-eye me-2"></i>ดูรายละเอียด
                          </button>
                          <button ngbDropdownItem type="button" (click)="viewRequestDetail(record)">
                            <i class="bi bi-file-earmark-text me-2"></i>เปิดใบคำขอ
                          </button>
                          <button ngbDropdownItem type="button" (click)="openStatusDialog(record)">
                            <i class="bi bi-cash-coin me-2"></i>ปรับสถานะการชำระเงิน
                          </button>
                          <button ngbDropdownItem type="button" (click)="openReceiptDialog(record)">
                            <i class="bi bi-pencil-square me-2"></i>แก้ไขใบเสร็จ
                          </button>
                          <div class="dropdown-divider"></div>
                          <button ngbDropdownItem type="button" (click)="printReceipt(record)"
                            [disabled]="!hasReceipt(record)">
                            <i class="bi bi-printer me-2"></i>พิมพ์ใบเสร็จ
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Pagination -->
          <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted">
                แสดงผล {{ collectionSize === 0 ? 0 : ((page - 1) * pageSize) + 1 }} -
                {{ min(page * pageSize, collectionSize) }}
                จาก {{ collectionSize }} รายการ
              </div>
              <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="collectionSize" [maxSize]="5"
                [rotate]="true" [boundaryLinks]="true" [size]="'sm'" (pageChange)="onPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ปรับสถานะการชำระเงิน -->
<ng-template #statusModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-cash-coin me-2"></i>ปรับสถานะการชำระเงิน
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body" *ngIf="statusTarget">
    <dl class="row mb-3">
      <dt class="col-sm-4">ผู้ทำรายการ</dt>
      <dd class="col-sm-8">{{ statusTarget.fullName || '-' }}</dd>
      <dt class="col-sm-4">ชื่อรายการ</dt>
      <dd class="col-sm-8">{{ statusTarget.itemTitle || '-' }} ({{ getTypeLabel(statusTarget.sourceType) }})</dd>
      <dt class="col-sm-4">จำนวนเงิน</dt>
      <dd class="col-sm-8">{{ formatCurrency(statusTarget.amount) }} บาท</dd>
      <dt class="col-sm-4">วันเวลาที่แจ้งโอน</dt>
      <dd class="col-sm-8">{{ getPaidAt(statusTarget) }}</dd>
      <dt class="col-sm-4">เลขที่ใบเสร็จ</dt>
      <dd class="col-sm-8 font-monospace">{{ statusTarget.codeReceipt || 'ยังไม่ออกใบเสร็จ' }}</dd>
    </dl>

    <div class="mb-3" *ngIf="statusTarget.paymentSlip">
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="openSlipPreview(statusTarget.paymentSlip!)">
        <i class="bi bi-receipt me-1"></i>ดูหลักฐานการชำระเงิน
      </button>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">สถานะการชำระเงิน</label>
      <select class="form-select form-select-lg" [(ngModel)]="statusValue"
        (ngModelChange)="onStatusSelectionChanged()">
        <option *ngFor="let status of getStatusOptions(statusTarget)" [value]="status">{{ status }}</option>
      </select>
    </div>

    <div class="mb-3" *ngIf="isCancelingPayment">
      <label class="form-label fw-semibold">เหตุผลการยกเลิก</label>
      <textarea class="form-control" rows="2" [(ngModel)]="statusCancelReason"
        placeholder="ระบุเหตุผลการยกเลิกใบเสร็จ"></textarea>
    </div>

    <div class="alert alert-success d-flex align-items-center" *ngIf="willIssueReceipt">
      <i class="bi bi-receipt-cutoff me-2 fs-5"></i>
      <span>เมื่อบันทึกเป็น "ชำระเงินเสร็จสิ้น" ระบบจะออกใบเสร็จและเลขที่ใบเสร็จให้ทันที</span>
    </div>

    <div class="alert alert-warning d-flex align-items-center" *ngIf="isCancelingPayment && statusTarget.codeReceipt">
      <i class="bi bi-exclamation-triangle me-2 fs-5"></i>
      <span>ใบเสร็จเลขที่ {{ statusTarget.codeReceipt }} จะถูกทำเครื่องหมายว่ายกเลิก</span>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">ยกเลิก</button>
    <button type="button" class="btn btn-success" (click)="savePaymentStatus(modal)" [disabled]="isSavingStatus">
      <span *ngIf="isSavingStatus" class="spinner-border spinner-border-sm me-2"></span>
      <i *ngIf="!isSavingStatus" class="bi bi-check-circle me-2"></i>บันทึกข้อมูล
    </button>
  </div>
</ng-template>

<!-- แก้ไขใบเสร็จ -->
<ng-template #receiptModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-pencil-square me-2"></i>แก้ไขใบเสร็จ
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body" *ngIf="receiptTarget">
    <div class="alert alert-info d-flex align-items-start">
      <i class="bi bi-info-circle-fill me-2 mt-1"></i>
      <div class="small">
        เปิดดูสลิปแล้วพบว่าวันเวลาที่ผู้ใช้แจ้งไม่ตรงกับสลิป แก้ไขได้ที่นี่
        ระบบจะแก้ไขใบเสร็จที่ออกไปแล้วให้ตรงกันด้วย
      </div>
    </div>

    <div class="mb-3" *ngIf="receiptTarget.paymentSlip">
      <button type="button" class="btn btn-outline-primary btn-sm"
        (click)="openSlipPreview(receiptTarget.paymentSlip!)">
        <i class="bi bi-receipt me-1"></i>ดูสลิปการโอน
      </button>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">
        <i class="bi bi-clock-history me-1"></i>วันที่และเวลาที่โอนเงิน
      </label>
      <input type="text" class="form-control form-control-lg" [(ngModel)]="receiptTransferDateTime"
        placeholder="เช่น 5 ตุลาคม 2569 เวลา 12:36 น.">
      <small class="text-muted">กรอกตามวันเวลาที่ปรากฏบนสลิปการโอน</small>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">
        <i class="bi bi-file-earmark-text me-1"></i>ประเภทใบเสร็จ
      </label>
      <div class="d-flex gap-3 flex-wrap">
        <div class="form-check">
          <input class="form-check-input" type="radio" id="receipt-type-individual" value="individual"
            [(ngModel)]="receiptTypeValue">
          <label class="form-check-label" for="receipt-type-individual">
            <i class="bi bi-person me-1"></i>ออกใบเสร็จแบบบุคคลธรรมดา
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="receipt-type-company" value="company"
            [(ngModel)]="receiptTypeValue">
          <label class="form-check-label" for="receipt-type-company">
            <i class="bi bi-building me-1"></i>ออกใบเสร็จแบบนิติบุคคล
          </label>
        </div>
      </div>
    </div>

    <div class="alert alert-secondary mb-0" *ngIf="receiptTarget.codeReceipt">
      ใบเสร็จเลขที่ <span class="fw-bold font-monospace">{{ receiptTarget.codeReceipt }}</span> จะถูกแก้ไขตามข้อมูลนี้
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">ยกเลิก</button>
    <button type="button" class="btn btn-success" (click)="saveReceiptInfo(modal)" [disabled]="isSavingReceipt">
      <span *ngIf="isSavingReceipt" class="spinner-border spinner-border-sm me-2"></span>
      <i *ngIf="!isSavingReceipt" class="bi bi-check-circle me-2"></i>บันทึกข้อมูล
    </button>
  </div>
</ng-template>

<!-- Payment Slip Preview (ย่อ-ขยายได้) -->
<div class="slip-preview-overlay" *ngIf="showSlipPreview" (click)="closeSlipPreview()"
  (mousemove)="onSlipDragMove($event)" (mouseup)="onSlipDragEnd()" (mouseleave)="onSlipDragEnd()">
  <div class="slip-preview-dialog" (click)="$event.stopPropagation()">
    <!-- Toolbar -->
    <div class="slip-preview-toolbar">
      <span class="slip-preview-title">
        <i class="bi bi-receipt me-2"></i>หลักฐานการชำระเงิน
      </span>

      <div class="slip-preview-actions">
        <ng-container *ngIf="!slipPreviewIsPdf">
          <button type="button" class="btn btn-sm btn-light" (click)="zoomSlipOut()" [ngbTooltip]="'ย่อ'">
            <i class="bi bi-zoom-out"></i>
          </button>
          <span class="slip-zoom-level">{{ slipZoomPercent }}%</span>
          <button type="button" class="btn btn-sm btn-light" (click)="zoomSlipIn()" [ngbTooltip]="'ขยาย'">
            <i class="bi bi-zoom-in"></i>
          </button>
          <button type="button" class="btn btn-sm btn-light" (click)="resetSlipZoom()" [ngbTooltip]="'ขนาดเดิม'">
            <i class="bi bi-arrow-counterclockwise"></i>
          </button>
        </ng-container>

        <button type="button" class="btn btn-sm btn-light" (click)="openSlipInNewTab()" [ngbTooltip]="'เปิดในแท็บใหม่'">
          <i class="bi bi-box-arrow-up-right"></i>
        </button>
        <button type="button" class="btn btn-sm btn-light" (click)="closeSlipPreview()" [ngbTooltip]="'ปิด'">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="slip-preview-body" [class.is-zoomed]="slipZoom > 1"
      (wheel)="!slipPreviewIsPdf && onSlipWheel($event)" (mousedown)="onSlipDragStart($event)">
      <iframe *ngIf="slipPreviewIsPdf" [src]="slipPreviewUrl | safe:'resourceUrl'" class="slip-preview-pdf"
        title="หลักฐานการชำระเงิน">
      </iframe>

      <img *ngIf="!slipPreviewIsPdf" [src]="slipPreviewUrl" alt="หลักฐานการชำระเงิน" class="slip-preview-image"
        [style.transform]="'translate(' + slipOffsetX + 'px, ' + slipOffsetY + 'px) scale(' + slipZoom + ')'"
        draggable="false">
    </div>

    <!-- Hint -->
    <div class="slip-preview-hint" *ngIf="!slipPreviewIsPdf">
      <i class="bi bi-info-circle me-2"></i>
      <span>เลื่อนลูกกลิ้งเมาส์เพื่อย่อ-ขยาย · ลากเพื่อเลื่อนภาพเมื่อขยายแล้ว · กด Esc หรือคลิกพื้นหลังเพื่อปิด</span>
    </div>
  </div>
</div>
